import moment from "moment";
import { dateFormats } from "../consts";
var formatData = function (data) {
    var finalData = [];
    var ecg_strips = [];
    var ppg_strips = [];
    for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var ecgSec = {
            series: i,
            ecg: item.ecg,
            timeArr: '',
            timestamp: item.timestamp,
        };
        // console.log('ecgSec', ecgSec)
        var ppgSec = {
            series: i,
            ppg: item.ppg,
            timeArr: '',
            timestamp: item.timestamp,
        };
        ecg_strips.push(ecgSec);
        ppg_strips.push(ppgSec);
        if (ecg_strips.length === 10 || i === data.length - 1) {
            // console.log('ecg_strips',ecg_strips)
            var ecg_10_sec = {
                strips: ecg_strips,
                type: "ecg",
                container: "ecg-ppg-container-".concat(i % 10)
            };
            var ppg_10_sec = {
                strips: ppg_strips,
                type: "ppg",
                container: "ecg-ppg-container-".concat(i % 10)
            };
            finalData.push(ecg_10_sec, ppg_10_sec);
            ecg_strips = [];
            ppg_strips = [];
        }
    }
    ;
    return finalData;
};
export var formatEcgPpgData = function (data) {
    var dataStructure = {
        ecg_ppg: {
            ecg_ppg_strips_sorted: formatData(data)
        }
    };
    return dataStructure;
};
export var getRealTimeRecordingTime = function (start, end, dateFormat) {
    var record = {
        start: moment(start),
        end: moment(end),
        startFormatted: moment(start).format(dateFormats.reportDateFull),
        endFormatted: moment(end).format(dateFormats.reportDateFull),
        total: 0
    };
    record.total = moment(record.end).diff(record.start, 'seconds');
    return record;
};
//# sourceMappingURL=ecg-ppg-utils.js.map